import {Link} from 'react-router-dom';
const Breadcrumb = ({breadtitle, breadmid, breadend}) => {
    return(
        <>
        <div className="breadcrumb">
                <h2>{breadtitle}</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>{breadmid}</li>
                    <li>|</li>
                    <li>{breadend}</li>
                </ul>
            </div>
        </>
    )
}
export default Breadcrumb